// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"91c93e28","814":"14694c05"}[chunkId] + ".chunk.js";
};